<template>
  <Modal
    :value="modalImportXmlIsOpen"
    :onClose="cancelImportXml"
    class="importationModal"
    size="large"
  >
    <Accordion id="importationTopCollapse" title="INFORMAÇÕES GERAIS">
      <b-row align-v="end">
        <b-col md="3" lg="4">
          <label for="input-live">Natureza de Operação</label>
          <b-form-input :value="importedInvoice.taxInformation.natOp" disabled />
        </b-col>
        <b-col md="4" lg="5">
          <label for="input-live">Chave de Acesso NFe:</label>
          <b-form-input id="nfeKey" :value="importedInvoice.taxInformation.nfe.nfeKey" disabled />
        </b-col>
        <b-col md="3" lg="2">
          <label for="input-live">NF. Número:</label>
          <b-form-input
            id="nfeNumber"
            :value="importedInvoice.taxInformation.nfe.nfeNumber"
            disabled
          />
        </b-col>
        <b-col md="2" lg="1">
          <label for="input-live">Série:</label>
          <b-form-input
            id="nfeSerie"
            :value="importedInvoice.taxInformation.nfe.nfeSerie"
            disabled
          />
        </b-col>
      </b-row>
      <b-row class="mt-2" align-v="end">
        <b-col md="3" lg="4">
          <label for="input-live">Fornecedor:</label>
          <b-form-input id="supplierName" :value="importedInvoice.supplier.name" disabled />
        </b-col>
        <b-col md="4">
          <label for="input-live">CPF/CNPJ:</label>
          <b-form-input
            id="supplierIdentification"
            :value="importedInvoice.supplier.identification"
            v-mask="[cpfMask, cnpjMask]"
            disabled
          />
        </b-col>
        <b-col md="3" lg="3">
          <label for="input-live">Endereço:</label>
          <b-form-input
            id="supplierAddressStreet"
            :value="importedInvoice.supplier.address.street"
            disabled
          />
        </b-col>
        <b-col md="2" lg="1">
          <label for="input-live">Número:</label>
          <b-form-input
            id="supllierAddressNumber"
            :value="importedInvoice.supplier.address.number"
            disabled
          />
        </b-col>
      </b-row>
      <b-row class="mt-2" align-v="end">
        <b-col md="6" lg="4">
          <label for="input-live">Bairro:</label>
          <b-form-input
            id="addressNeighbourhood"
            :value="importedInvoice.supplier.address.neighbourhood"
            disabled
          />
        </b-col>
        <b-col md="3" lg="2">
          <label for="input-live">CEP:</label>
          <b-form-input
            id="addressZipCodeCep"
            :value="importedInvoice.supplier.address.zipCode.zipCode"
            v-mask="cepMask"
            disabled
          />
        </b-col>
        <b-col>
          <label for="input-live">Cidade:</label>
          <b-form-input
            id="addressZipCodeCityName"
            :value="importedInvoice.supplier.address.zipCode.city.name"
            disabled
          />
        </b-col>
        <b-col md="2" lg="1">
          <label for="input-live">UF:</label>
          <b-form-input
            id="addressZipCodeUf"
            :value="importedInvoice.supplier.address.zipCode.city.state.acronym"
            disabled
          />
        </b-col>
        <b-col md="3" lg="2">
          <label for="input-live">Data Emissão:</label>
          <b-form-input
            id="issueDate"
            :value="formatDate(importedInvoice.taxInformation.issueDate)"
            disabled
          />
        </b-col>
      </b-row>
    </Accordion>

    <Accordion
      id="importationLinkedDocuments"
      title="DOCUMENTOS VINCULADOS"
      v-if="showLinkedDocuments"
    >
      <b-row>
        <b-col
          class="mt-2"
          md="6"
          v-for="(linkedDocument, index) in importedInvoice.linkedDocuments
            .linkedDocumentCollection"
          :key="index"
        >
          <b-form-input :value="linkedDocument.docKey" disabled />
        </b-col>
      </b-row>
    </Accordion>

    <Accordion id="importationProducts" title="PRODUTOS">
      <b-row class="margin-product-title">
        <b-col sm="4">
          <h4>Produtos</h4>
        </b-col>
      </b-row>
      <b-row
        class="table-import-products"
        v-if="importedInvoice.products.productOfPurchaseCollection.length"
      >
        <b-col>
          <table class="table tableFixHead">
            <thead>
              <tr>
                <th class="col-4">Desc.</th>
                <th>Cadastro Estoque</th>
                <th class="col-1">CFOP</th>
                <th class="col-1">Qtd</th>
                <th class="col-1">Unitário</th>
                <th>Uni. Conversão</th>
                <th class="col-1">Total</th>
                <th>
                  <a href="javascript:" @click="parametrizeAll">
                    <ArrangeBringToFront title="Parametrizar Todos" />
                  </a>
                </th>
                <th>
                  <a href="javascript:" @click="unparametrizeAll">
                    <ArrangeSendToBack title="Desparametrizar Todos" />
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, index) in importedInvoice.products.productOfPurchaseCollection"
                :key="index"
              >
                <td>
                  <b-form-input
                    id="productDescription"
                    style="min-width: 150px"
                    v-model="
                      importedInvoice.products.productOfPurchaseCollection[index].description
                    "
                    :value="product.description"
                    :disabled="productsInStock[index] !== null"
                  />
                </td>
                <td class="cadastro-estoque">
                  <SelectWithSearch
                    :filterBy="descriptionFilter"
                    placeholder="Selecione"
                    :id="index"
                    v-model="productsInStock[index]"
                    :options="productCollectionSelect"
                    :change="linkProduct"
                    :search="searchProduct"
                  >
                    <template slot="no-options">Nenhum produto encontrado</template>
                    <template slot="options" slot-scope="props">
                      <div class="selected">
                        {{ props.data.description }}
                      </div>
                    </template>
                    <template slot="selected" slot-scope="props">
                      <div
                        class="selected"
                        style="text-transform: uppercase"
                        v-b-tooltip.hover.top
                        :title="props.data.description"
                      >
                        {{ props.data.description }}
                      </div>
                    </template>
                  </SelectWithSearch>
                </td>
                <td>
                  <SelectWithSearch
                    :id="index"
                    class="cfop"
                    :change="changeCfop"
                    :options="adaptedCfopCollection"
                    :filterBy="descriptionFilter"
                    :clearable="false"
                    v-model="
                      importedInvoice.products.productOfPurchaseCollection[index].fiscal.values.cfop
                    "
                  >
                    <template slot="options" slot-scope="props">
                      <div class="selected">
                        {{ props.data.codigo }} - {{ props.data.descricao }}
                      </div>
                    </template>
                    <template slot="no-options"> Selecione um código </template>
                    <template slot="selected" slot-scope="props">
                      <div class="selected">
                        {{ props.data.codigo }} - {{ props.data.descricao }}
                      </div>
                    </template>
                  </SelectWithSearch>
                </td>
                <td id="quantityPurchased">
                  {{ roundAndFormat(product.quantityPurchased, decimalConfiguration.quantity) }}
                </td>
                <td class="table_ellipsis" id="productPrice">
                  {{ `R$ ${roundAndFormat(product.price, decimalConfiguration.price)}` }}
                </td>
                <td>
                  <SelectWithSearch
                    labelBusca="name"
                    placeholder="Selecione"
                    ref="searchCfop"
                    :id="index"
                    v-model="
                      importedInvoice.products.productOfPurchaseCollection[index].unitOfMeasure
                    "
                    :clearable="false"
                    :options="unitOfMeasureSelect"
                    :change="changeUnitOfMeasure"
                    :search="searchUnitOfMeasure"
                  >
                    <template slot="options" slot-scope="props">
                      <div class="selected" style="text-transform: uppercase">
                        {{ props.data.name }} - ({{
                          returnsCharacterOperator(props.data.converterOperator)
                        }}
                        {{ valorReal(props.data.converter) }})
                      </div>
                    </template>
                    <template slot="no-options">Nenhuma unidade encontrada</template>
                    <template slot="selected" slot-scope="props">
                      <div class="selected" style="text-transform: uppercase">
                        {{ props.data.acronym }}
                      </div>
                    </template>
                  </SelectWithSearch>
                </td>
                <td class="table_ellipsis" id="productTotalPrice">
                  {{
                    `R$ ${roundAndFormat(
                      product.price * product.quantityPurchased,
                      decimalConfiguration.price,
                    )}`
                  }}
                </td>
                <td align="right">
                  <a href="javascript:" @click="checkForChangeParametrization(index)">
                    <div
                      v-if="productsInStock[index] && productsInStock[index].productIsParametrized"
                    >
                      <ArrangeBringToFront title="Desparametrizar produto" />
                    </div>
                    <div v-else>
                      <ArrangeSendToBack title="Parametrizar produto" />
                    </div>
                  </a>
                </td>
                <td align="right">
                  <a
                    href="javascript:"
                    @click="removeProduct(index)"
                    class="remove-product text-muted"
                  >
                    <Close />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </Accordion>

    <Accordion id="importationBottomCollapse" title="TRANSPORTADORA/IMPOSTOS">
      <b-row>
        <b-col sm="5">
          <label for="input-live">Transportadora:</label>
          <b-form-input :value="importedInvoice.transport.shippingCompany.name" disabled />
        </b-col>
        <b-col sm="3">
          <label for="input-live">CPF/CNPJ:</label>
          <b-form-input
            :value="importedInvoice.transport.shippingCompany.identification"
            v-mask="[cpfMask, cnpjMask]"
            disabled
          />
        </b-col>
        <b-col sm="2">
          <label for="input-live">Desconto:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vDesc)" disabled />
        </b-col>
        <b-col sm="2">
          <label for="input-live">Valor Frete:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vFrete)" disabled />
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="2">
          <label for="input-live">Base ICMS:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vBC)" disabled />
        </b-col>
        <b-col sm="2">
          <label for="input-live">Valor ICMS:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vICMS)" disabled />
        </b-col>
        <b-col sm="2">
          <label for="input-live">Valor IPI:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vIPI)" disabled />
        </b-col>
        <b-col sm="2">
          <label for="input-live">Valor ST:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vICMSST)" disabled />
        </b-col>
        <b-col sm="2">
          <label for="input-live">Valor FCP ST:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vFCPST)" disabled />
        </b-col>
        <b-col sm="2">
          <label for="input-live">Seguro:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vSeg)" disabled />
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="2">
          <label for="input-live">Outras Despesas:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vOutro)" disabled />
        </b-col>
        <b-col sm="2">
          <label for="input-live">Total Produtos:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vProd)" disabled />
        </b-col>
        <b-col sm="2">
          <label for="input-live" class="align-self-end">Total nota:</label>
          <b-form-input :value="valorReal(importedInvoice.taxCalc.vNF)" disabled />
        </b-col>
      </b-row>
    </Accordion>
    <b-row class="margin-button-save" align="center">
      <b-col>
        <Button type="cancel" @click="cancelImportXml()">
          <Close class="mb-1" title="Cancelar" /> Cancelar
        </Button>
        <Button type="success" @click="importXmlToPurchase()">Importar</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { round } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import Close from 'vue-material-design-icons/Close';
import ArrangeSendToBack from 'vue-material-design-icons/ArrangeSendToBack';
import ArrangeBringToFront from 'vue-material-design-icons/ArrangeBringToFront';
import { Modal, Button, Accordion, SelectWithSearch } from '@/components';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import SearchMixin from '@/core/mixins/SearchMixin';
import NumberUtils from '@/core/Number';
import {
  MULTIPLIER,
  DIVIDER,
} from '../../../../UnitOfMeasure/enums/UnitOfMeasureConverterOperatorEnum';
import { orderTypeEnum } from '../../../../Shared/enums/orderTypeEnum';

export default {
  name: 'modalImportXml',
  mixins: [FormatMixin, SearchMixin],
  components: {
    Modal,
    Close,
    Button,
    Accordion,
    SelectWithSearch,
    ArrangeSendToBack,
    ArrangeBringToFront,
  },
  props: {
    confirm: {
      type: Function,
    },
  },
  data() {
    return {
      adaptedCfopCollection: [],
      productsInStock: [],
      cepMask: '#####-###',
      cpfMask: '###.###.###.##',
      cnpjMask: '##.###.###/####-##',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
    };
  },
  async mounted() {
    await this.setCfopCollection();
    await this.setUnitOfMeasureCollection();
    this.adaptCfopCollection();

    const { productOfPurchaseCollection } = this.importedInvoice.products;

    this.productsInStock = await productOfPurchaseCollection.map((e) => {
      if (!e?.productId) return null;

      const product = { ...e };
      product.description = e.stockDescription;
      return product;
    });

    this.setProductsInStock();
  },
  computed: {
    ...mapState('purchase', ['importedInvoice', 'transport', 'purchaseParams', 'taxInformation']),
    ...mapState('product', ['productCollection', 'productInventory']),
    ...mapState('unitOfMeasure', ['unitOfMeasureCollection']),
    ...mapState('fiscalComponents', ['cfopCollection']),
    ...mapState('componentsPurchase', ['modalImportXmlIsOpen']),
    ...mapGetters('purchase', [
      'decimalConfiguration',
      'productOfPurchaseCollectionXmlImportation',
    ]),
    ...mapState('purchase', [
      'purchase',
      'transport',
      'purchaseParams',
      'taxInformation',
      'importedInvoice',
    ]),

    unitOfMeasureSelect() {
      return this.unitOfMeasureCollection.slice(0, 5);
    },
    productCollectionSelect() {
      return this.productCollection.slice(0, 5);
    },
    showLinkedDocuments() {
      return this.importedInvoice?.linkedDocuments?.linkedDocumentCollection?.length;
    },
  },
  methods: {
    ...mapActions('purchase', [
      'setPurchase',
      'updateImportedInvoiceData',
      'setLinkedProducts',
      'setLinkedTaxInformation',
      'setPurchaseFromImport',
      'setShippingCompanyById',
      'setDecimalConfiguration',
      'clearXmlFormData',
      'setMatchedCfopForPurchaseTaxInformation',
    ]),
    ...mapActions('fiscalComponents', ['setCfopCollection']),
    ...mapActions('unitOfMeasure', ['setUnitOfMeasureCollection']),
    ...mapActions('product', ['setProductCollection', 'setProductInventory']),
    ...mapActions('componentsPurchase', ['toggleModalImportXml']),
    ...mapActions('person', [
      'setVehicleCollection',
      'setAddressCollection',
      'changeProductParametrization',
      'checkIfProductIsParametrized',
      'checkIfCodeHasParametrization',
      'unparametrizeAllProducts',
      'parametrizeAllProducts',
      'registerProducts',
    ]),
    adaptCfopCollection() {
      const [product] = this.productOfPurchaseCollectionXmlImportation;
      const { codigo } = product.fiscal.values.cfop;

      if (!codigo) {
        this.adaptedCfopCollection = this.cfopCollection.filter((e) => ['1', '2', '3'].includes(e.codigo[0]));
        return;
      }

      const prefix = codigo[0];
      this.adaptedCfopCollection = this.cfopCollection.filter((e) => e.codigo[0] === prefix);
    },
    async importXmlToPurchase() {
      await this.setLinkedProducts(this.productsInStock);
      await this.setPurchaseFromImport(this.importedInvoice);

      if (this.importedInvoice.transport.shippingCompany?.id) {
        await this.setShippingCompanyById(this.importedInvoice.transport);
        const { shippingCompany } = this.transport;
        await this.setAddressCollection(shippingCompany);
        await this.setVehicleCollection(shippingCompany);
      }

      this.toggleModalImportXml();
      this.buildTaxInformationCfop();
    },
    setProductsInStock() {
      this.productsInStock = this.importedInvoice.products.productOfPurchaseCollection.map((e) => {
        if (!e?.productId) return null;

        const product = { ...e };
        product.description = e.stockDescription || e.description;
        return product;
      });
    },
    buildTaxInformationCfop() {
      if (!this.taxInformation.natureza.cfop.id) return;

      this.setMatchedCfopForPurchaseTaxInformation({
        supplierId: this.importedInvoice.supplier.id,
        cfopIdPurchaseHeader: this.taxInformation.natureza.cfop.id,
      });
    },
    async cancelImportXml() {
      await this.clearXmlFormData();
      await this.toggleModalImportXml();
    },
    returnsCharacterOperator(operator) {
      return operator === MULTIPLIER ? 'x' : '/';
    },
    async searchUnitOfMeasure(search) {
      if (search) {
        await this.setUnitOfMeasureCollection({ search });
      }
    },
    changeCfop(selected, index) {
      if (!selected) return;

      const { fiscal } = this.importedInvoice.products.productOfPurchaseCollection[index];

      fiscal.values.cfop = selected;
      fiscal.ids.cfopId = selected.id;
    },
    changeUnitOfMeasure(selected, index) {
      if (!selected) return;

      this.importedInvoice.products.productOfPurchaseCollection[index].unitOfMeasure = selected;
    },
    async linkProduct(selected, index) {
      const productSelected = selected;

      if (!productSelected) {
        return this.productsInStock.splice(index, 1, null);
      }

      const isParametrized = await this.checkIfProductSelectedIsParametrized(
        productSelected,
        index,
      );

      productSelected.productIsParametrized = isParametrized;

      this.productsInStock.splice(index, 1, productSelected);

      return this.selectProductsWithSameCodeOrBarcode(index);
    },
    selectProductsWithSameCodeOrBarcode(index) {
      const { productOfPurchaseCollection } = this.importedInvoice.products;

      const supplierProductBarCode = productOfPurchaseCollection[index].barCode;
      const supplierProductCode = `${productOfPurchaseCollection[index].importationCode}|${productOfPurchaseCollection[index].description}`;

      productOfPurchaseCollection.forEach((productOfPurchase, key) => {
        if (this.productsInStock[key] === this.productsInStock[index]) return;
        const importationCode = `${productOfPurchase.importationCode}|${productOfPurchase.description}`;
        if (
          importationCode === supplierProductCode ||
          (NumberUtils.checkStringIsOnlyNumbers(productOfPurchase.barCode) &&
            productOfPurchase.barCode === supplierProductBarCode)
        ) {
          this.linkProduct(this.productsInStock[index], key);

          if (!this.$alert.isOpen) {
            this.$alert.warning(
              'Outros produtos possuem o mesmo código/código de barras e foram vinculados automaticamente.',
            );
          }
        }
      });
    },
    async searchProduct(search) {
      if (search) {
        await this.setProductCollection({ search, orderType: orderTypeEnum.PURCHASE });
      }
    },
    async checkIfProductSelectedIsParametrized(product, index) {
      const supplierId = this.importedInvoice.supplier.id;
      const productId = product.id;
      const supplierCode = this.importedInvoice.products.productOfPurchaseCollection[index]
        .importationCode;

      const isParametrized = await this.checkIfProductIsParametrized({
        supplierId,
        productId,
        supplierCode,
      });

      return isParametrized;
    },
    getProductsInStockData() {
      return this.productsInStock.map((product, index) => {
        const supplierCode = this.importedInvoice.products.productOfPurchaseCollection[index]
          .importationCode;
        const unitOfMeasureId = this.importedInvoice.products.productOfPurchaseCollection[index]
          .unitOfMeasure.id;

        return {
          productId: product?.productId || product?.id,
          unitOfMeasureId,
          supplierCode,
        };
      });
    },
    async registerProductsInStock(onlyThisIndex = -1) {
      const updatedProductOfPurchaseCollection = this.importedInvoice.products.productOfPurchaseCollection.map(
        (product, index) => {
          const newProduct = { ...product };

          newProduct.productId =
            this.productsInStock[index]?.productId || this.productsInStock[index]?.id;

          if (newProduct.productId) {
            newProduct.description =
              newProduct.description ||
              this.productsInStock[index]?.description ||
              this.productsInStock[index]?.stockDescription;
          }

          if (!newProduct.productId) {
            newProduct.stockDescription = newProduct.description;
          }

          return newProduct;
        },
      );

      const productOfPurchaseCollection =
        onlyThisIndex >= 0
          ? [updatedProductOfPurchaseCollection[onlyThisIndex]]
          : updatedProductOfPurchaseCollection;

      const data = {
        ...this.importedInvoice,
        products: { productOfPurchaseCollection },
      };

      return this.registerProducts({
        data,
      });
    },
    parametrizeAll() {
      const productsData = this.getProductsInStockData();
      const supplierId = this.importedInvoice.supplier.id;

      const itemsWithPendingProducts = this.importedInvoice.products.productOfPurchaseCollection.filter(
        (_, index) => !productsData[index]?.productId,
      );

      const createPendingProductsMessage = itemsWithPendingProducts.length
        ? ' o cadastro no estoque e'
        : '';

      const message = `Deseja efetuar${createPendingProductsMessage} a parametrização de todos os itens vinculados?`;

      this.confirm({
        title: 'Confirmação',
        message,
        onOk: async () => {
          if (itemsWithPendingProducts.length) {
            const data = await this.registerProductsInStock();
            await this.updateImportedInvoiceData({
              products: data.products,
            });

            this.setProductsInStock();
          }

          await this.parametrizeAllProducts({
            supplierId,
            productsData: this.getProductsInStockData(),
          });

          this.productsInStock = this.productsInStock.map((e) => {
            if (!e) return null;

            const product = { ...e };

            product.productIsParametrized = true;

            return product;
          });
        },
      });
    },
    unparametrizeAll() {
      const allSupplierProductCodes = this.importedInvoice.products.productOfPurchaseCollection.map(
        (product) => product.importationCode,
      );
      const supplierId = this.importedInvoice.supplier.id;

      this.confirm({
        title: 'Confirmação',
        message: 'Deseja desparametrizar todos os itens desse XML?',
        onOk: () => {
          this.unparametrizeAllProducts({
            supplierId,
            allSupplierProductCodes,
          });

          this.productsInStock = this.productsInStock.map((e) => {
            if (!e) return null;

            const product = { ...e };

            product.productIsParametrized = false;

            return product;
          });
        },
      });
    },
    async checkForChangeParametrization(index) {
      if (this.productsInStock[index]) {
        return this.changeParametrization(index);
      }

      const description = this.importedInvoice.products.productOfPurchaseCollection[index]
        ?.description;

      return this.confirm({
        title: 'Confirmação',
        message: `O Item "${description}" ainda não foi criado no estoque, deseja criar o produto e depois parametrizá-lo?`,
        onOk: async () => {
          const data = await this.registerProductsInStock(index);
          const [recentlyCreatedProduct] = data.products.productOfPurchaseCollection;
          this.importedInvoice.products.productOfPurchaseCollection.splice(
            index,
            1,
            recentlyCreatedProduct,
          );
          this.productsInStock[index] = {
            ...recentlyCreatedProduct,
            description:
              recentlyCreatedProduct.stockDescription || recentlyCreatedProduct.description,
          };

          return this.changeParametrization(index);
        },
      });
    },
    async changeParametrization(index) {
      const supplierId = this.importedInvoice.supplier.id;
      const productId = this.productsInStock[index].id || this.productsInStock[index].productId;
      const supplierCode = this.importedInvoice.products.productOfPurchaseCollection[index]
        .importationCode;
      const unitOfMeasureId = this.importedInvoice.products.productOfPurchaseCollection[index]
        .unitOfMeasure.id;
      const isParametrized = this.productsInStock[index].productIsParametrized === true;

      const parametrizationData = await this.checkIfCodeHasParametrization({
        supplierId,
        supplierCode,
      });

      let modalMessage = parametrizationData.hasParametrization
        ? `Esse item está parametrizado para o produto: ${parametrizationData.productCode} - ${parametrizationData.productDescription}, deseja reparametrizar?`
        : 'O código do produto selecionado será vinculado (fornecedor com produto) para facilitar importações futuras. Confirma operação?';

      if (isParametrized) {
        modalMessage = 'Deseja mesmo desparametrizar esse item?';
      }

      this.confirm({
        title: 'Confirmação',
        message: modalMessage,
        onOk: () => {
          this.changeProductParametrization({
            supplierId,
            productId,
            supplierCode,
            unitOfMeasureId,
            isParametrized,
          });

          this.productsInStock[index].productIsParametrized = !isParametrized;

          this.setProductCollection({ search: '', orderType: orderTypeEnum.PURCHASE });
        },
      });
    },
    removeProduct(index) {
      this.productsInStock.splice(index, 1);
      this.importedInvoice.products.productOfPurchaseCollection.splice(index, 1);
    },
  },
};
</script>
<style>
.importationModal > .panel {
  background: #eef0ef !important;
}

.cadastro-estoque {
  max-width: 250px;
}

.cfop {
  max-width: 150px;
}

.table-import-products {
  height: 284px;
  overflow: auto;
}

.margin-product-title {
  margin-top: 30px;
  margin-bottom: -10px;
}

.table_ellipsis {
  max-width: 135px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tableFixHead thead th {
  position: sticky;
  top: 0;
  z-index: 1000;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th {
  background: #ffffff;
}
</style>

<style scoped>
.b-tooltip {
  z-index: 1110 !important;
  opacity: 1;
}
</style>
